import { getNextBtn } from './controller'

export const NEXT = () => new Promise(resolve => {
    const handleNextClick = e => {
        getNextBtn().removeEventListener('click', handleNextClick)
        resolve('next')
    }
    getNextBtn().addEventListener('click', handleNextClick)
})
